import api from '@/services/api';

export const useDeleteAssistant = () => {
  const deleteAssistant = async (id: string) => {
    const response = await api.delete(`/api/v1/assistants/${id}`);
    return response.data;
  };

  const deleteAssistantFile = async (id: string, fileId: string) => {
    const response = await api.delete(`/api/v1/assistants/${id}/files/${fileId}`);
    return response.data;
  };

  return { deleteAssistant, deleteAssistantFile };
};
